module.exports = __webpack_public_path__ + "static/media/locknox-1.8a1ee94c.jpg";